import { ProcessModelType } from "../../types/Finance";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get, post, put } from "../../utils/axios-config";
import { PROCESS_MODELS } from "../../utils/constants";

export const createProcessModel = async (data: ProcessModelType) =>
  await post<ProcessModelType, string>(PROCESS_MODELS, data);

export const updateProcessModel = async (data: ProcessModelType) =>
  await put<ProcessModelType, string>(PROCESS_MODELS, data);

export const getProcessModels = async (data?: PagedRequestType) => {
  const queryParams = new URLSearchParams({
    PageNumber: data?.PageNumber?.toString() || "1",
    PageSize: data?.PageSize?.toString() || "100",
  });
  if (data?.CourseLevel) {
    queryParams.append('Level', data.CourseLevel);
  }

  if (data?.CourseModality) {
    queryParams.append('Modality', data.CourseModality);
  }

  if (data?.ProcessName) {
    queryParams.append('ProcessName', data.ProcessName);
  }
  const url = `${PROCESS_MODELS}?${queryParams.toString()}`;
  return await get<PagedResultsType<ProcessModelType>>(url);
};